<template>
  <Dialog
    :visible="show"
    modal
    rtl
    :closable="false"
    :pt="{
      header: {
        style: {'display': 'none'}
      }
    }"
    :style="{ width: '85dvw', height: 'max-content', 'max-height': '85dvh' }"
  >
    <div class="flex flex-col justify-center items-center p-4">
      <div class="mb-4 w-16 h-16 flex justify-center items-center">
        <loader size="large"/>
      </div>
      <h2 class="text-xl font-semibold mb-2">
        {{ stageText }}
      </h2>
      <p v-if="stage === 'downloading'" class="text-gray-600 text-center">
        אנא המתינו בזמן שאנו מעדכנים את האפליקציה
      </p>
      <p v-else-if="stage === 'restarting'" class="text-gray-600 text-center">הורדנו את העדכון האחרון, האפליקציה תופעל
        מחדש</p>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { computed} from 'vue';
import Spinner from '@app/components/Spinner.vue';

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  stage: {
    type: String,
    default: 'downloading' // 'downloading' or 'restarting'
  }
});

const stageText = computed(() => {
  switch (props.stage) {
  case 'downloading':
    return 'מעדכן גרסא';
  case 'restarting':
    return 'מפעיל אפליקציה מחדש';
  default:
    return 'מעדכן גרסא';
  }
});
</script>

<style scoped>
/* Add any additional styling here */
</style>
